import { createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ApiClient from "helpers/ApiClient";

const initialState: any = {
  lawyersList: [],
  loading:false
};

export const getLawyers:any = createAsyncThunk<any>(
  "getLawyers/setLawyers",
  async (_, thunkAPI) => {
    try {
      const response = await ApiClient.get(`manage-services/find?type=Lawyers&address=79.8%2C28.6&limit=1000`);
      return response?.data?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const lawyersSlice = createSlice({
  name: "getLawyers",
  initialState,
  reducers: {
    setLawyers(state, action) {
      state.lawyersList = action.payload;
    },
  },
  extraReducers: {
    [getLawyers.pending]: (state:any) => {
      state.loading = true
    },
    [getLawyers.fulfilled]: (state:any, action: any) => {
      state.loading = false
      state.lawyersList = action.payload;
    },
    [getLawyers.rejected]: (state:any) => {
      state.loading = false
    },
  },
});

export const { setLawyers } = lawyersSlice.actions;
export default lawyersSlice;
